import ComboFoodManagement from '@/modules/health-consulting-management/combo-food-management';
import { PermissionMode } from '@/enums/mode.enum';
import { useQuery } from '@/hooks/query.hook';
import ComboFoodManagementCreateForm from '../../components/forms/combo-food-management/menu.form';
import ComboFoodByList from '../../components/tables/combo-food-management/combo-food-by-list.table';

export default function ComboFoodSlider() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      case PermissionMode.CREATE:
        return <ComboFoodManagementCreateForm />;
      case PermissionMode.EDIT:
        return <ComboFoodManagementCreateForm />;
      case PermissionMode.GROUP:
        return <ComboFoodByList />;
      default:
        return <ComboFoodManagement />;
    }
  };
  return <>{renderContent()}</>;
}
